import React from 'react';
import { Navbar } from './Navbar';
import { useAuth } from '@/contexts/AuthContext';
import { Outlet, Navigate } from 'react-router-dom';

interface LayoutProps {
  requireAuth?: boolean;
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ requireAuth = false, children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-background/95" role="status" aria-label="Loading">
        <div className="flex flex-col items-center gap-2">
          <div className="h-10 w-10 rounded-full border-4 border-t-primary animate-spin" aria-hidden="true"></div>
          <div className="text-lg md:text-xl text-muted-foreground">Loading...</div>
        </div>
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-background/95">
      {/* Skip to main content link for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none"
      >
        Skip to main content
      </a>
      
      <Navbar />
      <main id="main-content" className="container mx-auto py-4 md:py-6 lg:py-8 px-3 sm:px-4 md:px-6 lg:px-8">
        {children || <Outlet />}
      </main>
    </div>
  );
};
